import { createComponent } from "@front/utils/alpine";
import { YoutubeIframeAPI } from "@front/services/youtube";

export default createComponent(({ $persist, $defaults }) => ({
    videoId: '',
    player: null as null | YT.Player,

    async setup () {
        if (!this.videoId) {
            return;
        }

        await YoutubeIframeAPI.ready;
        this.player = new YT.Player(this.$refs.placeholder, {
            videoId: this.videoId,
            width: '100%',
            height: '100%',
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                autoplay: 1,
                autohide: 1,
                disablekb: 1,
                showinfo: 0,
                modestbranding: 1,
                loop: 1,
                fs: 0,
                rel: 0,
                enablejsapi: 1,
                playsinline: 1,
                start: 0,
                mute: 1,
                origin: window.location.host,
            },
        });
    },

    init (video) {
        YoutubeIframeAPI.load();
        this.videoId = this.$el.dataset.videoId;
    },
}));
